import LoyaltyList from '@app/Loyalty/List'
import LoyaltyListUkraine from '@app/Loyalty/ListUkraine'

export default function install(Vue) {
  Vue.component('LoyaltyList', LoyaltyList)
  Vue.component('LoyaltyListUkraine', LoyaltyListUkraine)
}
